import React from 'react';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useFeedbackStatuses } from './hooks/useFeedbackStatuses';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const FeedbackStatusFilter = () => {
  const { t } = useTranslation();
  const { filterValues, updateFilter, isShowAll, initialValues } = useFilters();
  const showAllEnabled = isShowAll('feedbackStatus');
  const feedbackStatuses = useFeedbackStatuses(showAllEnabled);

  // Clean, declarative initialization
  useFilterInitialization('feedbackStatus', feedbackStatuses, {
    waitForData: true,
    persistAll: true,
    getDefaultValue: () => {
      // Check if 'all' is stored in initialValues
      const storedValue = initialValues.feedbackStatus;
      
      // If 'all' is stored, use the show all option with empty id
      if (storedValue === 'all') {
        return SHOW_ALL_OPTION;
      }
      
      // Otherwise default to Outstanding
      return { id: "O", name: t("label.outstanding"), statusType: "O", groupBy: "Outstanding" };
    },
    getParams: (item) => ({ 
      feedbackStatusID: item.id,
      statusType: item.statusType || ''
    })
  });

  if (!filterValues.feedbackStatus) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={feedbackStatuses}
        columns={[{ name: 'name', id: 1, minWidth: '130px' }]}
        columnsMinWidths={[140, 140, 140, 140, 140]}
        showHeader={false}
        width="100%"
        placeholder={t("placeholder.selectStatus")}
        onChange={item => updateFilter('feedbackStatus', item, { 
          feedbackStatusID: item.id,
          statusType: item.statusType || ''
        }, true)}
        selectdValueToshow="name"
        selectedValue={filterValues.feedbackStatus?.value}
        label={t("label.filterByStatus")}
        isServerSide={false}
        icon={<FilterListIcon style={{ color: 'rgb(48, 122, 215)' }} />}
        required={false}
        showBorderColor
        groupBy={[
          { ...SHOW_ALL_OPTION, statusType: "" },
          { id: "C", name: t("label.complete"), statusType: "C", groupBy: "Complete" },
          { id: "O", name: t("label.outstanding"), statusType: "O", groupBy: "Outstanding" },
        ]}
        hasGroup
      />
    </Grid>
  );
}; 
